import { render, staticRenderFns } from "./AppHeader.html?vue&type=template&id=1011a4f4&"
import script from "./AppHeader.js?vue&type=script&lang=js&"
export * from "./AppHeader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports